(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-ceremonial"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainers = document.querySelectorAll('.mk-image-row-container');
  const imageRowContainer = imageRowContainers.length > 0 ? imageRowContainers[imageRowContainers.length - 1] : null;
  
  if (!pageBreadcrumbs || !imageRowContainer) return;
  
  function checkImageRowPosition() {
    const imageRowRect = imageRowContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
    // Keep hidden once the image-row has been reached
    if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
      pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
    } else {
      pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
    }
  }
  
  window.addEventListener('scroll', checkImageRowPosition, { passive: true });
  checkImageRowPosition();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainers = document.querySelectorAll('.mk-image-row-container');
  const imageRowContainer = imageRowContainers.length > 0 ? imageRowContainers[imageRowContainers.length - 1] : null;
  
  if (!pageBreadcrumbs || !imageRowContainer) return;
  
  function checkImageRowPosition() {
    const imageRowRect = imageRowContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
    // Keep hidden once the image-row has been reached
    if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
      pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
    } else {
      pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
    }
  }
  
  window.addEventListener('scroll', checkImageRowPosition, { passive: true });
  checkImageRowPosition();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionQuestions = document.querySelectorAll('.mk-accordion-item-question');
    
    accordionQuestions.forEach(function(question) {
      question.addEventListener('click', function() {
        const accordionItem = this.closest('.mk-accordion-item');
        accordionItem.classList.toggle('mk-accordion-item--open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anniversary"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["back-to-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isCollectionUrl(url) {
    return url.pathname.indexOf('/collections/') === 0 || url.pathname === '/collections';
  }

  function init() {
    var button = document.getElementById('back-to-collection-button');
    if (!button) return;

    var url;
    try {
      url = document.referrer ? new URL(document.referrer) : null;
    } catch (e) {
      url = null;
    }

    if (!url || url.origin !== window.location.origin || !isCollectionUrl(url)) return;

    button.href = url.pathname + url.search + url.hash;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-aggregated"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const { OverlayScrollbars } = OverlayScrollbarsGlobal;

    const scrollContainers = document.querySelectorAll('.mk-collection-row-products');
    scrollContainers.forEach(function(container) {
      OverlayScrollbars(container, {
        overflow: { x: 'scroll', y: 'hidden' },
        scrollbars: {
          theme: 'os-theme-dark',
          visibility: 'auto',
          autoHide: 'never',
          autoHideDelay: 800
        }
      });
    });

    const collectionList = document.querySelector('.mk-collection-list');
    if (collectionList) {
      OverlayScrollbars(collectionList, {
        overflow: { x: 'scroll', y: 'hidden' },
        scrollbars: {
          theme: 'os-theme-dark',
          visibility: 'auto',
          autoHide: 'never',
          autoHideDelay: 800
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-featurecollections"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const { OverlayScrollbars } = OverlayScrollbarsGlobal;

    const scrollContainers = document.querySelectorAll('.mk-collection-row-products');
    scrollContainers.forEach(function(container) {
      OverlayScrollbars(container, {
        overflow: { x: 'scroll', y: 'hidden' },
        scrollbars: {
          theme: 'os-theme-dark',
          visibility: 'auto',
          autoHide: 'never',
          autoHideDelay: 800
        }
      });
    });

    const collectionList = document.querySelector('.mk-collection-list');
    if (collectionList) {
      OverlayScrollbars(collectionList, {
        overflow: { x: 'scroll', y: 'hidden' },
        scrollbars: {
          theme: 'os-theme-dark',
          visibility: 'auto',
          autoHide: 'never',
          autoHideDelay: 800
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-stones"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const { OverlayScrollbars } = OverlayScrollbarsGlobal;

    const scrollContainers = document.querySelectorAll('.mk-collection-row-products');
    scrollContainers.forEach(function(container) {
      OverlayScrollbars(container, {
        overflow: { x: 'scroll', y: 'hidden' },
        scrollbars: {
          theme: 'os-theme-dark',
          visibility: 'auto',
          autoHide: 'never',
          autoHideDelay: 800
        }
      });
    });

    const collectionList = document.querySelector('.mk-collection-list');
    if (collectionList) {
      OverlayScrollbars(collectionList, {
        overflow: { x: 'scroll', y: 'hidden' },
        scrollbars: {
          theme: 'os-theme-dark',
          visibility: 'auto',
          autoHide: 'never',
          autoHideDelay: 800
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamonds"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-image-toggle')) {
      const listContainer = document.querySelector('.mk-list-container');
      if (listContainer) {
        listContainer.classList.toggle('mk-list-container--images');
      }
    }
    
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Footer accordion toggle for mobile
  document.body.addEventListener('click', function(e) {
    if (e.target.matches('.mk-footer-column-title') || e.target.closest('.mk-footer-column-title')) {
      e.preventDefault();
      
      const column = e.target.closest('.mk-footer-column');
      if (!column) return;
      
      column.classList.toggle('mk-footer-column--open');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemstones"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  // Prevent transitions during resize
  if (pageBreadcrumbs) {
    let resizeTimer;
    window.addEventListener('resize', function() {
      pageBreadcrumbs.classList.add('resize-animation-stopper');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        pageBreadcrumbs.classList.remove('resize-animation-stopper');
      }, 400);
    });
  }
  
  // Add class when page has scrolled 83px from top
  if (pageBreadcrumbs) {
    function checkScrollPosition() {
      if (window.scrollY >= 83) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--animation');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--animation');
      }
    }
    
    window.addEventListener('scroll', checkScrollPosition, { passive: true });
    checkScrollPosition();
  }
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      // Keep hidden once the image-row has been reached
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  // Image cycling
  const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
  let index = 0;

  function showNext() {
    if (slides.length === 0) return;
    // Hide all slides
    slides.forEach(s => s.style.display = 'none');
    // Show current
    slides[index].style.display = 'block';
    // Move to next, loop if at end
    index = (index + 1) % slides.length;
    setTimeout(showNext, 2000);
  }

  // Hide all slides initially
  slides.forEach(s => s.style.display = 'none');
  if (slides.length > 0) showNext();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-to-order"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-image-toggle')) {
      const listContainer = document.querySelector('.mk-list-container');
      if (listContainer) {
        listContainer.classList.toggle('mk-list-container--images');
      }
    }
    
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  // Toggle list items
  document.addEventListener('click', function(e) {
    if (e.target.closest('.mk-list-item-image-toggle')) {
      const listContainer = document.querySelector('.mk-list-container');
      if (listContainer) {
        listContainer.classList.toggle('mk-list-container--images');
      }
    }
    
    if (e.target.closest('.mk-list-item-toggle')) {
      const listItem = e.target.closest('.mk-list-item');
      if (listItem) {
        listItem.classList.toggle('mk-list-item--show');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.loadRecommendations();
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error('Error loading product recommendations:', e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Image cycling functionality
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();

    // Anchor links functionality
    const paragraphs = document.querySelectorAll('.mk-text-container-list p');
    paragraphs.forEach(p => {
      const text = p.textContent.trim();
      const anchor = text.toLowerCase().replace(/\s+/g, '');
      p.innerHTML = `<a href="#${anchor}">${p.innerHTML}</a>`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit"]) return;
  try {
    
  // Breadcrumb fade out when image-row is in view
  const pageBreadcrumbs = document.querySelector('[data-page-breadcrumbs]');
  const imageRowContainer = document.querySelector('.mk-image-row-container');
  
  if (pageBreadcrumbs && imageRowContainer) {
    function checkImageRowPosition() {
      const imageRowRect = imageRowContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Fade out breadcrumbs when full image-row is visible on page or has scrolled past
      if (imageRowRect.top <= 0 || (imageRowRect.top >= 0 && imageRowRect.bottom <= windowHeight)) {
        pageBreadcrumbs.classList.add('mk-breadcrumbs--hidden');
      } else {
        pageBreadcrumbs.classList.remove('mk-breadcrumbs--hidden');
      }
    }
    
    window.addEventListener('scroll', checkImageRowPosition, { passive: true });
    checkImageRowPosition();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.mk-image-and-text-container .mk-page-slide');
    let index = 0;

    function showNext() {
      if (slides.length === 0) return;
      // Hide all slides
      slides.forEach(s => s.style.display = 'none');
      // Show current
      slides[index].style.display = 'block';
      // Move to next, loop if at end
      index = (index + 1) % slides.length;
      setTimeout(showNext, 2000);
    }

    // Hide all slides initially
    slides.forEach(s => s.style.display = 'none');
    if (slides.length > 0) showNext();
  });

  } catch(e) { console.error(e); }
})();
})();
